module.exports = __webpack_public_path__ + "img/ctrl-r-theta-stub-down-0.495c55a0.svg";